<template>
	<div class="text-left">
		<h1 class="left-align">Messages History</h1>
		<v-data-table
      :headers="headers"
      :items="messages"
			:loading="isLoading"
      item-key="messageId"
      show-expand
			single-expand
    >
			<template v-for="h in headers" v-slot:[`header.${h.value}`]="{ header }">
				<span :key="h.value" class="columnTitleText" tabIndex="0" v-on:keyup.enter="(e) => e.target.click()">{{h.text}}</span>
			</template>
			<template v-slot:top>
				<v-toolbar>
					<v-dialog v-model="dialogEdit" max-width="90%" persistent>
            <v-card max-width="98%">
              <v-card-title class="headline">Edit Message</v-card-title>
							<v-card-text>
                <v-container>
									<v-row>
                    <v-col>
                      <v-text-field
                        v-model="editedItem.messageTitle"
                        label="Title"
                      ></v-text-field>
                    </v-col>
									</v-row>
									<v-row>
                    <v-col>
											<vue-editor required v-model="editedItem.messageBody" :editor-toolbar="customToolbar"></vue-editor>
                    </v-col>
									</v-row>
									<v-row no-gutters v-if="editedItem.messageType === 'BANNER'">
										<v-menu
												ref="menu"
												v-model="menu2"
												:close-on-content-click="false"
												:nudge-right="40"
												:return-value.sync="dates"
												transition="scale-transition"
												offset-y
												min-width="290px"
											>
												<template v-slot:activator="{ on }">
													<v-text-field
														v-model="dateRangeText"
														label="Date Range"
														prepend-inner-icon="event"
														readonly
														outlined
														v-on="on"
													></v-text-field>
												</template>
												<v-date-picker v-model="dates" range no-title scrollable>
													<v-spacer></v-spacer>
													<v-btn color="primary" @click="menu2 = false">Cancel</v-btn>
													<v-btn color="primary" @click="$refs.menu.save(dates)">OK</v-btn>
												</v-date-picker>
											</v-menu>
									</v-row>
								</v-container>
							</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text class="btn-default" @click="close">Cancel</v-btn>
                <v-btn class="btn-default" text @click="save">Save</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
					<v-dialog v-model="dialogDelete" max-width="600px" class="delete-study-dialog" persistent>
            <v-card max-width="580px">
              <v-card-title class="headline">Are you sure you want to delete this message?</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="btn-default" text @click="closeDelete">Cancel</v-btn>
                <v-btn class="btn-default" text @click="deleteItemConfirm">OK</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
				</v-toolbar>
			</template>
      <template v-slot:expanded-item="{ headers, item }">
				<td></td>
					<td :colspan="headers.length - 1" style="padding:10px 0px 10px 0px">
						<v-data-table
							:headers="item.messageType == 'BANNER' ? expandBannerHeaders : expandHeaders"
							:items="getExpandedInfo(item)"
							hide-default-footer
						>
							<template v-slot:item.html-message="{ item }">
								<p v-html="item.messageBody"></p>
							</template>
							<template v-slot:item.dateStart="{ item }">
								{{ getFormattedDate(item.dateStart) }}
							</template>
							<template v-slot:item.dateEnd="{ item }">
								{{ getFormattedDate(item.dateEnd) }}
							</template>
							<template v-slot:item.message-actions="{ item }">
								<v-icon
									v-if="item.messageType !== 'EMAIL'"
									small
									class="mr-2"
									@click="editItem(item)"
								>
									mdi-pencil
								</v-icon>
								<v-icon
									small
									@click="deleteItem(item)"
								>
									mdi-delete
								</v-icon>
							</template>
						</v-data-table>
					</td>
      </template>
			<template v-slot:item.dateRecorded="{ item }">
				{{ getFormattedDate(item.dateRecorded) }}
			</template>
			<template v-slot:item.dateUpdated="{ item }">
				{{ getFormattedDate(item.dateUpdated) }}
			</template>
    </v-data-table>
	</div>
</template>

<script>
import { VueEditor } from 'vue2-editor';
import { researcherApiService } from '@/services/researcherApiService.js';
import { utilityService } from '@/services/utilityService.js';
export default {
	name: 'messageHistory',
	components: {
		VueEditor
	},
	data: () => ({
		messages: [],
		headers: [
			{ text: '', value: 'data-table-expand', class: 'data-table-header' },
			{ text: 'Title', value: 'messageTitle', class: 'data-table-header' },
			{ text: 'Type', value: 'messageType', class: 'data-table-header' },
			{ text: 'Created', value: 'dateRecorded', class: 'data-table-header' },
			{ text: 'Updated', value: 'dateUpdated', class: 'data-table-header' }
		],
		expandHeaders: [
			{ text: 'Message', value: 'html-message', class: 'data-table-header' },
			{ text: 'Actions', value: 'message-actions', class: 'data-table-header' }
		],
		expandBannerHeaders: [
			{ text: 'Message', value: 'html-message', class: 'data-table-header' },
			{ text: 'Start Date', value: 'dateStart', class: 'data-table-header' },
			{ text: 'End Date', value: 'dateEnd', class: 'data-table-header' },
			{ text: 'Actions', value: 'message-actions', class: 'data-table-header' }
		],
		dialogEdit: false,
		dialogDelete: false,
		editedIndex: -1,
		editedItem: {
			messageTitle: '',
			messageBody: '',
			dateStart: null,
			dateEnd: null,
			dateRecorded: null,
			dateRecordedBy: null,
			dateRecordedByUuid: null,
			dateUpdated: null,
			dateUpdatedBy: null,
			dateUpdatedByUuid: null,
			messageId: null,
			messageType: null,
			messageUserUuid: null
		},
		defaultItem: {
			messageTitle: '',
			messageBody: '',
			dateStart: null,
			dateEnd: null,
			dateRecorded: null,
			dateRecordedBy: null,
			dateRecordedByUuid: null,
			dateUpdated: null,
			dateUpdatedBy: null,
			dateUpdatedByUuid: null,
			messageId: null,
			messageType: null,
			messageUserUuid: null
		},
		dates: [],
		menu2: false,
		isLoading: false,
		customToolbar: [
			[{ header: [false, 1, 2, 3] }],
			['bold', 'italic', 'underline', 'strike'],
			[{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
			['blockquote', 'code-block'],
			[{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
			[{ indent: '-1' }, { indent: '+1' }],
			[{ background: ['#FFFF00'] }],
			['image', 'link', 'video'],
			['clean']
		]
	}),
	mounted () {
		this.loadMessages();
	},
	methods: {
		async loadMessages () {
			this.isLoading = true;
			const me = this;
			await researcherApiService.getAllMessages()
				.then(async function (response) {
					if (response && response.data) {
						me.messages = response.data.data;
					}
					me.isLoading = false;
				})
				.catch(function (e) {
					console.log(e);
					me.$store.dispatch('changeUpdateStatusWithMessage', { status: 'admin-message-failure', message: 'There was an error loading the message history.' });
					me.isLoading = false;
				});
		},
		getExpandedInfo (item) {
			var itemArray = [];
			itemArray.push(item);

			return itemArray
		},
		getFormattedDate (date) {
			if (date && date.length) {
				return utilityService.formatDate(date);
			}

			return 'N/A';
		},
		editItem (item) {
			this.editedIndex = this.messages.indexOf(item);
			this.editedItem = Object.assign({}, item);
			this.dates.push(this.getFormattedDate(this.editedItem.dateStart));
			this.dates.push(this.getFormattedDate(this.editedItem.dateEnd));
			this.dialogEdit = true;
		},
		deleteItem (item) {
			this.editedIndex = this.messages.indexOf(item);
			this.editedItem = Object.assign({}, item);
			this.dialogDelete = true;
		},
		deleteItemConfirm () {
			const me = this;
			researcherApiService.deleteMessage(this.editedItem.messageId)
				.then(function (response) {
					if (response) {
						me.messages.splice(me.editedIndex, 1);
						me.dialogDelete = false;
					}
				})
				.catch(function (e) {
					console.log(e);
					// TODO: Display banner message with error
					me.closeDelete();
				});
		},
		close () {
			this.dialogEdit = false
			this.$nextTick(() => {
				this.editedItem = Object.assign({}, this.defaultItem);
				this.editedIndex = -1;
				this.dates = [];
			})
		},
		closeDelete () {
			this.dialogDelete = false
			this.$nextTick(() => {
				this.editedItem = Object.assign({}, this.defaultItem);
				this.editedIndex = -1;
			})
		},
		save () {
			if (this.editedIndex > -1) {
				this.editedItem.dateStart = this.dates[0];
				this.editedItem.dateEnd = this.dates[1];
				const me = this;
				console.log(JSON.stringify(this.editedItem));

				researcherApiService.updateAdminMessage(this.editedItem.messageId, this.editedItem.messageBody)
					.then(function (response) {
						if (response) {
							Object.assign(me.messages[me.editedIndex], me.editedItem);
							me.$store.dispatch('changeUpdateStatus', { status: 'admin-message-success' });
							me.close();
						}
					})
					.catch(function (e) {
						let errorMessage = 'Your admin message failed to submit.';
						if (e.response.data.messages) {
							errorMessage = e.response.data.messages[0]
						}
						me.$store.dispatch('changeUpdateStatusWithMessage', { status: 'admin-message-failure', message: errorMessage });
						me.close();
					});
			}
		}
	},
	computed: {
		dateRangeText () {
			return this.dates.join(' ~ ');
		}
	}
}
</script>

<style>

</style>
